module.exports = __webpack_public_path__ + "img/connect_logo2.12a22c0b.png";